import { Button, Grid } from "@mui/material";
import { NumberFormatter } from "utils/helpers";
import { useStyles } from "./basket-content-style";
import { useTranslation } from "react-i18next";
import { BookingJourney_Paths, ELEMENT_ID } from "utils/constants";
import { useNavigate } from "react-router-dom";
import { ShoppingCartOutlined } from "@mui/icons-material";
import { ProductBasket } from "store/bookingJourney";

type ContentProps = {
  handleClose: () => void | null;
  setbasketContentDrawerOpen: (smallDrawer: boolean) => void | null;
  products: ProductBasket[];
  isMobile: boolean;
};

export const BasketAction: React.FC<ContentProps> = ({
  products,
  handleClose,
  setbasketContentDrawerOpen,
  isMobile,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClick = (path: string) => {
    isMobile ? setbasketContentDrawerOpen(false) : handleClose();
    if (location.pathname !== path) {
      navigate(path);
    }
  };

  const onClose = () => {
    isMobile ? setbasketContentDrawerOpen(false) : handleClose();
  };

  const total = products?.reduce((sum, product) => sum + product.subTotal, 0);

  return (
    <Grid className={classes.basketActionWrapper}>
      <Grid container className={classes.totalPriceContainer}>
        <Grid className={classes.totallabel}>{t("total")}</Grid>
        <Grid id={`${ELEMENT_ID.BASKETCONTENT}-${ELEMENT_ID.TOTAL}`} className={classes.total}>
          {NumberFormatter(products[0].currency).format(total)}
        </Grid>
      </Grid>
      <Grid container className={classes.vatContainerLabel}>
        {t("excl_vat_text")}
      </Grid>
      <Grid container className={classes.actionButtonsContainer}>
        <Button
          onClick={onClose}
          id={`${ELEMENT_ID.BASKETCONTENT}-${ELEMENT_ID.CONTINUESHOPPING}`}
          className={classes.continueShopping}
          aria-label={t("continue_shopping")}
        >
          {t("continue_shopping")}
        </Button>
        <Button
          id={`${ELEMENT_ID.BASKETCONTENT}-${ELEMENT_ID.PROCEEDTOCHECKOUT}`}
          variant="contained"
          endIcon={<ShoppingCartOutlined className={classes.arrowForward} />}
          className={classes.btnClass}
          aria-label={t("proceed_to_Checkout")}
          onClick={() => handleClick(BookingJourney_Paths.Summary)}
        >
          {t("proceed_to_Checkout")}
        </Button>
      </Grid>
    </Grid>
  );
};
